import { render, staticRenderFns } from "./editSponsorsEdition.vue?vue&type=template&id=60652eac"
import script from "./editSponsorsEdition.vue?vue&type=script&lang=js"
export * from "./editSponsorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports